import React, { useEffect, useState } from "react"
import './style.css';
import { Link } from "react-router-dom";
import img from './img/logo.png'
import img2 from './img/logo2.png'
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import config from "../config/config";
import { useNavigate, useLocation } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import userAction, { setApiToken, setUserInfo } from "../actions/userActions";
import { getUserData, getUserInfoData } from "../actions/userdata";
import { authMe } from "../Utils/utils";

const Login = (props) => {
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate()
  const dispatch = useDispatch();





  const loginUser = async () => {
    try {
      if (userName == '') {
        toast.error('Please enter username!')
      }
      if (password == '') {
        toast.error('Please enter password!')
      }
      if (userName != '' && password != '') {
        const formData = new FormData();
        formData.append("username", userName)
        formData.append("password", password)

        let path = config.siteUrl;
        const response = await axios.post(path + '/login', formData, {
        })
        const res = response?.data;
        if (res?.status == 200) {
          localStorage.setItem('access_token', `Bearer ${res?.data?.token}`)
          localStorage.setItem('user_data', JSON.stringify(res?.data?.User))
          toast.success(res?.message)
          props.setUserInfo(res.data.User)
          props.setApiToken(res.data.token)
          setTimeout(() => navigate(`/dashboard`), 3000);
        } else {
          toast.error(res?.message)
        }
      }
    } catch (error) {
      console.error(error);

    }
  }






  useEffect(() => {
    if (props.apiToken !== "") {
      navigate('/dashboard')
    } else if (localStorage.getItem('access_token')) {
      navigate('/dashboard')
    }
  }, [props])

  return (
    <>
      <div className="Login">
        <ToastContainer
          position="top-center"
        />
        <div className="row w-100">
          <div className="col-md-3"></div>
          <div className="col-md-6">
            <div className="container">
              <div className="row">
                <img src={img2} className="logo-img" />
                <div className="col-md-8 d-flex flex-column mx-auto">
                  <div className="card card-raised shadow-10 mt-5 mt-xl-5 mb-4"
                    style={{ borderRadius: "12px", border: "none", background: "#EFF2FC" }}>
                    <div className="card-header pb-0 text-center bg-transparent" style={{ borderBottom: "none" }}>
                      {/* <img className="mb-3" alt="..." style={{ height: "58px" }} /> */}
                      <h5 className="font-weight-bolder text-dark text-gradient">{("Login")}</h5>
                      <p>{("Enter your username and password to sign in")}</p>
                    </div>
                    <div className="card-body">
                      <div role="form text-left">
                        <span>{("Username")}</span>
                        <div className="mb-3">
                          <input className="form-control mt-2 mb-2" type="text" name="username" placeholder={("Username")}
                            onChange={e => setUserName(e.target.value)}
                          />
                        </div>
                        <span>{("Password")}</span>
                        <div className="mb-3">
                          <input className="form-control mt-2 mb-2" type="password" name="password"
                            placeholder={("Password")}
                            onChange={e => setPassword(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.keyCode == 13 || e.key == "Enter") {
                                loginUser()
                              }
                            }}
                          />
                        </div>
                        {/* <Link to="/register">
                          <span>want a new account ? start it now</span>
                        </Link> */}
                        <br />
                        {/* <Link to="/upload"> */}
                        <button id="submit" type="submit" className="btn mt-3 bg-warning text-white"
                          onClick={loginUser}

                        >{("Login")}</button>
                        {/* </Link> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3"></div>
        </div>


      </div >
    </>
  )
}
// export default Login

const mapDispatchToProps = (dispatch) => {
  return {
    setUserInfo: (apiToken) => dispatch(setUserInfo(apiToken)),
    setApiToken: (apiToken) => dispatch(setApiToken(apiToken)),
  };
};

const mapStateToProps = (state) => {
  return {
    userdata: state.userInfo,
    apiToken: state.apiToken
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Login);


